import { useRef, useState } from 'react';
import { initMsw } from './init-msw';

const development = process.env.NODE_ENV === 'development';
const msw = process.env.MSW;

export const useAwaitInitMsw = () => {
  const [resolved, setResolved] = useState<boolean>(
    development && msw
      ? false
      : true,
  );

  const promise = useRef<Promise<void> | null>(null);

  if (!resolved) {
    promise.current ||= initMsw().then(
      () => setResolved(true),
    );
  }

  return resolved;
};
